<template>
  <div>
    <div class="hdzq">
      <img v-if="stockImage != ''" :src="stockImage" width="100%">
      <img v-if="stockImage == ''" src="../assets/img/1029.png" width="100%">
      <div class="wrap special_wrap">
        <div class="hdzqt">
          <span class="bigleft_title">优惠专区</span>
          <div class="hdzqtr">
            <span >
              <router-link to="/stockactivity">
                  进行中
                </router-link>
            </span>
            <span class="now">
              <router-link to="/stockunactivity">
                已结束
                </router-link>
            </span>
          </div>
        </div>
        <!--hdzqt end-->
        <div class="hdzqm">
          <!--进行中-->
          <div class="activity_typebox">
            <ul>
              <li v-for="(item,index) in activeList">
                <img :src="item.title" :alt="item.name">
                <div class="hdzqmb">
                  <h2>{{ item.name }}</h2>
                  <p>时间：{{ item.start_date }}  -  {{ item.end_date }}</p>
                  <span>马上参加</span>
                </div>
                <router-link :to="{path:'/stockguild',query:{activityid:item.id}}"  title="新年开市红包等你拿">
                  查看活动
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: "stockunactivity",
      data() {
        return {
          activeList:[],
          stockImage:''
        };
      },
      components: {
  },
      methods:{
      get_banner() {
      let that = this;
      that.$http({
        url: "/",
        method: "POST",
        data: {
          nozzle: 'sysconfig',
          name: 'stock_image'
        }
      })
        .then(ret => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.stockImage = resData.data;
          }
        });
      },
        getActivity(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "POST",
            data: {
              'nozzle': 'active_unactivitylist',
            }
          })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                that.activeList = resData.data;
                for (let i = 0, len = that.activeList.length;i < len; i++){
                  that.activeList[i].start_date = that.$moment(that.activeList[i].start_date, "YYYY.MM.DD").format('YYYY-MM-DD');
                  that.activeList[i].end_date = that.$moment(that.activeList[i].end_date, "YYYY.MM.DD").format('YYYY-MM-DD')
                }
              }else{
                that.$alert('请稍后尝试','提示',{
                  confirmButtonText: '确定',
                })
              }
            });
        }
      },
      mounted: function () {
        let that = this;
        this.getActivity();
        this.get_banner();
      },
    }
</script>

<style scoped>
  @import url("./../assets/css/style.css");
  .hdzqt span{display: inline-block;line-height: 32px; color: #444; font-size: 24px;}
  .hdzqt .bigleft_title{padding-left:30px;position:relative;}
  .hdzqt .bigleft_title:before{display: block;content:"";position: absolute;left: 0;top: 0;height:28px;width: 4px;background: #d44139;margin-top:3px;}
  .hdzqtr{display: inline-block;float: right;}
  .hdzqtr span{cursor:pointer;display: inline-block;border: 1px solid #ddd; color: #aaa; line-height: 30px; height: 30px;width: 85px;text-align: center;margin-left: 10px; border-radius: 16px;font-size: 14px;}
  .hdzqtr span:hover,.hdzqtr span.now{ background: #d44139; border: 1px solid #d44139;color:#fff; }
  .hdzqm{}
  .hdzqm li{ float: left;box-shadow: 0 0 5px 1px #ccc;width: 380px; margin:0 30px 35px 0; position: relative; background: #fff; }
  .hdzqm li img{vertical-align: top;width: 380px; height: 271px;}
  .hdzqmb{padding: 10px 20px 16px; position: relative;}
  .hdzqmb h2{    margin-bottom: 12px;font-weight: bold;font-size: 20px;color: #666;height: 26px;overflow: hidden;width: 80%;text-overflow: ellipsis;white-space: nowrap;}
  .hdzqmb p{overflow: hidden;text-overflow: ellipsis;height: 38px;}
  .hdzqmb span{display: inline-block;width: 80px;height: 20px; text-align: center; line-height: 20px;border-radius: 10px 0 0 10px; color: #fff;position: absolute;right: 0; top: 12px;background:#fd9800;padding-left: 20px;font-size: 14px;}
  .hdzqm li:after{z-index: 1; transition: all 0.3s; position: absolute;display:none;content: "";left: 0;top: 0; width: 100%;height: 100%; background: #000000;opacity: .6;text-align: center;}
  .hdzqm li a{    z-index: 2;position: absolute;display:none;left: 50%;top: 50%;transform: translate(-50%,-50%);width: 150px;height: 50px;line-height: 50px;border-radius: 6px;background: #fd9800;
    color: #fff;font-size: 20px;text-align: center; transition: all 0.3s;}
  .hdzqm li:hover:after,.hdzqm li:hover a{display: block;}
  .hdzqm li:nth-child(3n){ margin-right: 0 }
  .hdzq {
  }
  .special_wrap {
    width: 1200px;
    margin: 0 auto;
    overflow:hidden
  }
  body{
    list-style:none;
  }
  .hdzqtr span.now a {
    color: #ffffff;
  }
  .hdzqtr span a {
    color: #cccccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/stockunactivity.vue